import type { Breadcrumb } from 'types/capi/shared';

import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';

type Props = {
  breadcrumbs: Breadcrumb[];
};

const BreadcrumbItem = ({
  breadcrumb,
  includeSeparator,
  onClick
}: {
  breadcrumb: Breadcrumb;
  includeSeparator: boolean;
  onClick: () => void;
}) => {
  return (
    <li data-cy="breadcrumb" className="text-caption-grey">
      {includeSeparator ? <span className="px-3">•</span> : ''}
      <a href={breadcrumb.path} onClick={onClick}>
        {breadcrumb.label}
      </a>
    </li>
  );
};

const Breadcrumbs = ({ breadcrumbs }: Props) => {
  const fireNavigationLink = useNavigationLinkInteraction('breadcrumb');

  return (
    <nav>
      <ul className="flex">
        {breadcrumbs.map((breadcrumb, i) => (
          <BreadcrumbItem
            data-cy={`breadcrumb:${i}`}
            key={breadcrumb.path}
            breadcrumb={breadcrumb}
            includeSeparator={i > 0}
            onClick={() =>
              fireNavigationLink(breadcrumb.path, i + 1, {
                label: breadcrumb.label
              })
            }
          />
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
